/** Canonical identity icon names for memory categories and conversations, in picker order.
 * The browser mirror is byte-pinned by webMirrorContracts. Empty values use the surface's default. */
export const ICON_ALLOWLIST = [
  'Briefcase', 'Server', 'Database', 'Heart', 'Code', 'Home', 'Star', 'Folder', 'Globe', 'Book',
  'Cpu', 'Terminal', 'Rocket', 'Lightbulb', 'Target', 'Calendar', 'DollarSign', 'ShoppingCart',
  'Music', 'Camera', 'MapPin', 'Zap', 'Flag', 'Bookmark', 'MessageCircle',
] as const;

/** @externalConsumer Byte-pinned web/lib/categoryIconNames.ts supplies the browser icon picker type. */
export type MemoryCategoryIcon = (typeof ICON_ALLOWLIST)[number];
export const DEFAULT_ICON = 'Folder';
